import { CheckboxInput, FormItem } from '@framework/form';
import * as React from 'react';

export interface ILayoutHideConfigInputProps {}

export function LayoutHideConfigInput(props: ILayoutHideConfigInputProps) {
  return (
    <FormItem
      name="layout.hide"
      label={null}
      layout={{ removeLabelSpace: true }}
    >
      <CheckboxInput name="layout.hide" defaultChecked={false}>
        Nascondi elemento in compilazione
      </CheckboxInput>
    </FormItem>
  );
}
